export const STC = 'stc/' as const
export const STC_ADMIN = `${STC}admin/` as const
export const STC_ALL = `${STC}all` as const
export const STC_CATEGORY = `${STC}category/` as const
export const STC_CATEGORY_ALL = `${STC_CATEGORY}all` as const

export const STC_CHAPTER = `${STC}chapter/` as const
export const STC_CHAPTER_ALL = `${STC_CHAPTER}all` as const
export const STC_CHAPTER_CREATE_BATCH = `${STC_CHAPTER}batch` as const

export const STC_STEP = `${STC}step/` as const
export const STC_STEP_ADMIN = `${STC}step/admin/` as const
export const STC_STEP_ALL = `${STC_STEP}all` as const
export const STC_STEP_ADMIN_ALL = `${STC_STEP_ADMIN}all` as const
export const STC_STEP_COMPLETE = `${STC_STEP}complete` as const

export const STC_TOPIC = `${STC}topic/` as const
export const STC_TOPIC_ALL = `${STC_TOPIC}all` as const
